<template>
	<div class="app-container">
		<!-- 搜索栏 -->
		<el-card class="filter-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAdd">
						<el-icon>
							<Plus />
						</el-icon> 新增线索
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical" />
				</el-form-item>
				<el-form-item label="线索名称">
					<el-input v-model="searchForm.leadsName" style="width: 180px" placeholder="请输入线索名称" clearable />
				</el-form-item>
				<el-form-item label="客户名称">
					<!-- <el-input v-model="filterForm.customerName" placeholder="请输入客户名称" clearable @keyup.enter="handleSearch" /> -->
					<el-select v-model="searchForm.customerId" style="width: 180px" placeholder="请选择客户" filterable
						remote :remote-method="handleCustomerSearch" :loading="customerSearchLoading" clearable>
						<el-option v-for="item in customerOptions" :key="item.id" :label="item.customerName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="客户名称">
          <el-input v-model="searchForm.customerName" placeholder="请输入客户名称" clearable />
        </el-form-item> -->
				<!-- <el-form-item label="跟进状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="未跟进" :value="0" />
            <el-option label="跟进中" :value="1" />
          </el-select>
        </el-form-item> -->
				<el-form-item label="转化状态">
					<el-select v-model="searchForm.isTransform" placeholder="选择状态" clearable style="width: 130px;">
						<el-option label="未转化" :value="0" />
						<el-option label="已转化" :value="1" />
					</el-select>
				</el-form-item>
				<el-form-item label="线索归属">
					<el-select v-model="searchForm.type" placeholder="选择归属" style="width: 130px;">
						<el-option label="全部" value="all" />
						<el-option label="我的" value="my" />
						<el-option label="下属的" value="subordinate" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleSearch">
						<el-icon>
							<Search />
						</el-icon>搜索
					</el-button>
					<el-button @click="resetSearch">
						<el-icon>
							<Refresh />
						</el-icon>重置
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 数据表格 -->
		<el-card class="table-card" shadow="hover">
			<el-table :data="tableData" height="calc(100vh - 320px)" v-loading="loading" stripe style="width: 100%"
				ref="leadTable">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="leadsName" label="线索名称" min-width="150" show-overflow-tooltip />
				<el-table-column prop="customerName" label="客户名称" min-width="150" show-overflow-tooltip />
				<el-table-column prop="followup" label="跟进状态" width="120">
					<template #default="{ row }">
						<el-tag :type="getFollowupStatusType(row.followup || 0)">
							{{ getFollowupStatusText(row.followup || 0) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="isTransform" label="转化状态" width="120">
					<template #default="{ row }">
						<el-tag :type="getTransformStatusType(row.isTransform || 0)">
							{{ getTransformStatusText(row.isTransform || 0) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="ownerName" label="负责人" width="120" show-overflow-tooltip />
				<el-table-column prop="createTime" label="创建时间" width="200">
					<template #default="{ row }">
						{{ formatDateTime(row.createTime) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200" fixed="right">
					<template #default="{ row }">
						<el-button size="small" type="warning" @click="handleView(row)">查看</el-button>
						<el-button size="small" type="primary" @click="handleEdit(row)"
							v-if="row.isTransform !== 1">编辑</el-button>
						<!-- <el-button size="small" type="success" @click="handleConvert(row)"
							v-if="row.isTransform !== 1">转化</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="pagination-container">
				<el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
					:page-sizes="[10, 20, 50, 100]" :total="total" layout="total, sizes, prev, pager, next, jumper"
					@size-change="handleSizeChange" @current-change="handleCurrentChange" />
			</div>
		</el-card>

		<!-- 新增/编辑对话框 -->
		<el-dialog v-model="dialogVisible" :title="dialogType === 'add' ? '新增线索' : '编辑线索'" width="40vw">
			<el-card shadow="never">
				<el-form ref="formRef" :model="form" :rules="rules" label-width="auto">
					<el-form-item label="线索名称" prop="leadsName">
						<el-col :span="16">
							<el-input v-model="form.leadsName" placeholder="请输入线索名称" />
						</el-col>
					</el-form-item>
					<el-form-item label="所属客户" prop="customerName">
						<el-col :span="18">
							<!-- <el-select v-model="form.customerId" filterable placeholder="请选择客户">
								<el-option v-for="customer in customerList" :key="customer.id"
									:label="customer.customerName" :value="customer.id">
								</el-option>
							</el-select> -->
							<el-input v-model="form.customerName" placeholder="请输入客户名称" />
						</el-col>
					</el-form-item>
					<el-form-item label="联系电话" prop="mobile">
						<el-col :span="16">
							<el-input v-model="form.mobile" placeholder="请输入线索名称" />
						</el-col>
					</el-form-item>
					<el-form-item label="跟进状态" prop="followup">
						<el-col :span="14">
							<el-select v-model="form.followup" placeholder="请选择状态">
								<el-option label="未跟进" :value="0" />
								<el-option label="跟进中" :value="1" />
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="是否公开" prop="status">
						<el-col :span="14">
							<el-select v-model="form.status" placeholder="请选择状态">
								<el-option label="公开" :value="0" />
								<el-option label="私有" :value="1" />
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="转化状态" prop="isTransform">
						<el-col :span="14">
							<el-select v-model="form.isTransform" placeholder="请选择状态">
								<el-option label="未转化" :value="0" />
								<el-option label="已转化" :value="1" />
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="负责人" prop="ownerUserId">
						<el-col :span="14">
							<el-select v-model="form.ownerUserId" placeholder="选择负责人" filterable remote
								:remote-method="(query) => handleUserSearch(query)" :loading="userSearchLoading"
								@change="handleUserChange($event, index)">
								<el-option v-for="user in userOptions" :key="user.id" :label="user.username"
									:value="user.id">
									<span>{{ user.username }}</span>
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input v-model="form.remark" type="textarea" placeholder="请输入备注" :rows="3" />
					</el-form-item>
				</el-form>
			</el-card>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="handleSubmit">
						确定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 转化对话框 -->
		<el-dialog v-model="convertDialogVisible" title="转化线索" width="500px">
			<el-form ref="convertFormRef" :model="convertForm" :rules="convertRules" label-width="100px">
				<el-form-item label="客户名称" prop="customerName">
					<el-input v-model="convertForm.customerName" placeholder="请输入客户名称" />
				</el-form-item>
				<el-form-item label="客户类型" prop="customerType">
					<el-select v-model="convertForm.customerType" placeholder="请选择客户类型">
						<el-option label="个人" value="personal" />
						<el-option label="企业" value="company" />
					</el-select>
				</el-form-item>
				<el-form-item label="转化备注" prop="remark">
					<el-input v-model="convertForm.remark" type="textarea" placeholder="请输入转化备注" />
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="convertDialogVisible = false">取消</el-button>
					<el-button type="primary" @click="handleConvertSubmit">
						确定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 分配对话框 -->
		<el-dialog v-model="assignDialogVisible" title="分配线索" width="400px">
			<el-form ref="assignFormRef" :model="assignForm" :rules="assignRules" label-width="100px">
				<el-form-item label="负责人" prop="owner">
					<el-select v-model="assignForm.owner" placeholder="请选择负责人">
						<el-option v-for="user in userList" :key="user.id" :label="user.name" :value="user.id" />
					</el-select>
				</el-form-item>
				<el-form-item label="分配备注" prop="remark">
					<el-input v-model="assignForm.remark" type="textarea" placeholder="请输入分配备注" />
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="assignDialogVisible = false">取消</el-button>
					<el-button type="primary" @click="handleAssignSubmit">
						确定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 线索详情对话框 -->
		<el-dialog title="线索详情" v-model="viewDialogVisible" width="800px">
			<el-tabs v-model="activeTab">
				<el-tab-pane label="基本信息" name="basic">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="线索名称">{{ currentLead.leadsName || '--' }}</el-descriptions-item>
						<el-descriptions-item
							label="客户名称">{{ currentLead.customerName || '--' }}</el-descriptions-item>
						<!-- <el-descriptions-item
							label="联系人">{{ currentLead.customers?.customerContacts?.[0]?.name || '--' }}</el-descriptions-item> -->
						<el-descriptions-item
							label="联系电话">{{ currentLead.mobile || '--' }}</el-descriptions-item>
						<el-descriptions-item label="线索状态">
							<el-tag :type="getTransformStatusType(currentLead.isTransform)">
								{{ getTransformStatusText(currentLead.isTransform) }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="跟进状态">
							<el-tag :type="getFollowupStatusType(currentLead.followup)">
								{{ getFollowupStatusText(currentLead.followup) }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item
							label="创建时间">{{ formatDateTime(currentLead.createTime) || '--' }}</el-descriptions-item>
						<el-descriptions-item label="备注说明"
							:span="2">{{ currentLead.remark || '无' }}</el-descriptions-item>
					</el-descriptions>
				</el-tab-pane>

				<!-- <el-tab-pane label="跟进记录" name="followup">
          <el-timeline>
            <el-timeline-item
              v-for="(record, index) in followupRecords"
              :key="index"
              :timestamp="formatDateTime(record.createTime)"
              :type="getFollowupType(record.type)">
              <div class="timeline-item-content">
                <h4>{{ record.title }}</h4>
                <p><strong>跟进方式：</strong>{{ getFollowupMethod(record.method) }}</p>
                <p><strong>跟进内容：</strong>{{ record.content }}</p>
                <p><strong>跟进人：</strong>{{ record.username }}</p>
                <p v-if="record.nextTime"><strong>下次跟进时间：</strong>{{ formatDateTime(record.nextTime) }}</p>
              </div>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane> -->

				<el-tab-pane label="相关报价" name="quotations" v-if="quotations.length > 0">
					<el-table :data="quotations" border style="width: 100%">
						<el-table-column type="index" label="序号" width="60" />
						<el-table-column prop="name" label="报价编号" min-width="150"></el-table-column>
						<el-table-column prop="offerPrice" label="报价金额" width="120">
							<template #default="scope">
								{{ formatAmount(scope.row.offerPrice) }}
							</template>
						</el-table-column>
						<el-table-column prop="status" label="状态" width="100">
							<template #default="scope">
								<el-tag :type="getQuotationStatusType(scope.row.status)">
									{{ getQuotationStatusText(scope.row.status) }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="createTime" label="创建时间" width="150">
							<template #default="scope">
								{{ formatDateTime(scope.row.createTime) }}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100" fixed="right">
							<template #default="scope">
								<el-button size="mini" type="primary"
									@click="handleViewQuotation(scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import dayjs from 'dayjs'
	import {
		getUserListQ
	} from '@/api/auth'
	import {
		getCustomerList
	} from '@/api/customer'
	import {
		searchCustomers
	} from '@/api/payment'
	import {
		getLeadList,
		addLead,
		updateLead,
		deleteLead,
		convertLead,
		assignLead,
		// getLeadDetail,
		// getLeadFollowupList,
		// getLeadQuotations
	} from '@/api/lead'
	import {
		debounce
	} from 'lodash-es'

	export default {
		name: 'LeadManagement',
		data() {
			return {
				// 搜索表单
				searchForm: {
					leadsName: '',
					customerName: '',
					status: '',
					isTransform: '',
					type: 'all'
				},

				// 表格数据
				userSearchLoading: false,
				loading: false,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,

				// 对话框
				dialogVisible: false,
				dialogType: 'add',
				form: {
					leadsName: '',
					customerId: '',
					status: 0,
					isTransform: 0,
					ownerUserId: '',
					remark: '',

				},

				// 转化对话框
				convertDialogVisible: false,
				convertForm: {
					customerName: '',
					customerType: '',
					remark: ''
				},

				// 分配对话框
				assignDialogVisible: false,
				assignForm: {
					owner: '',
					remark: ''
				},
				customerOptions: [],
				customerSearchLoading: false,

				// 用户列表
				userList: [],

				// 当前操作的线索ID
				currentLeadId: null,

				// 表单验证规则
				rules: {
					leadsName: [{
							required: true,
							message: '请输入线索名称',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 50,
							message: '长度在 2 到 50 个字符',
							trigger: 'blur'
						}
					],
					customerName: [{
						required: true,
						message: '请选择客户',
						trigger: 'change'
					}],
					followup: [{
						required: true,
						message: '请选择跟进状态',
						trigger: 'change'
					}],
					ownerUserId: [{
						required: true,
						message: '请选择负责人',
						trigger: 'change'
					}],
					mobile:[{
						required: true,
						message: '请输入手机号',
						trigger: 'change'
					}]
				},

				// 转化表单验证规则
				convertRules: {
					customerName: [{
						required: true,
						message: '请输入客户名称',
						trigger: 'blur'
					}],
					customerType: [{
						required: true,
						message: '请选择客户类型',
						trigger: 'change'
					}]
				},

				// 分配表单验证规则
				assignRules: {
					owner: [{
						required: true,
						message: '请选择负责人',
						trigger: 'change'
					}]
				},

				viewDialogVisible: false,
				activeTab: 'basic',
				currentLead: {},
				followupRecords: [],
				quotations: [],
				resizeObserver: null,
				rafId: null
			}
		},
		created() {
			this.fetchCustomers()
			this.fetchData()
		},
		computed: {
			...mapState({
				username: state => state.user.username,
				userId: state => state.user.id,
				isBoss: state => state.user.isBoss
			})
		},
		methods: {
			async fetchCustomers() {
				try {
					const res = await getCustomerList({
						current: 1,
						size: 1000
					})
					this.customerList = res.data.records
				} catch (error) {
					console.error('获取客户列表失败:', error)
				}
			},
			// 获取状态类型
			getStatusType(status) {
				if (status === null || status === undefined) return 'info'
				const types = {
					0: 'info', // 未转化
					1: 'success' // 已转化
				}
				return types[status] || 'info'
			},
			async handleUserSearch(query) {
				const res = await getUserListQ({
					name: query
				})
				this.userOptions = res.data
			},
			handleUserChange(userId) {
				const user = this.userOptions.find(u => u.id === userId)
				if (user) {
					this.form.owner = user.username
					// this.processForm.tbTemUsers[index].departmentName = user.departmentName
				}
			},

			// 获取状态文本
			getStatusText(status) {
				if (status === null || status === undefined) return '未知'
				const texts = {
					0: '未转化',
					1: '已转化'
				}
				return texts[status] || '未知'
			},

			// 添加时间格式化方法
			formatDateTime(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
			},

			// 获取线索列表
			async fetchData() {
				this.loading = true
				try {
					const res = await getLeadList({
						current: this.currentPage,
						size: this.pageSize,
						...this.searchForm
					})
					// 格式化时间
					this.tableData = res.data.records.map(item => ({
						...item,
						createTime: this.formatDateTime(item.createTime)
					}))
					this.total = res.data.total
				} catch (error) {
					console.error('获取线索列表失败:', error)
				} finally {
					this.loading = false
				}
			},

			// 搜索
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},

			// 重置搜索
			resetSearch() {
				this.searchForm = {
					leadsName: '',
					customerName: '',
					status: '',
					isTransform: '',
					type: 'all'
				}
				this.handleSearch()
			},

			// 分页
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},

			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},

			// 新增线索
			handleAdd() {
				this.dialogType = 'add'
				this.form = {
					leadsName: '',
					customerId: '',
					status: 0,
					isTransform: 0,
					ownerUserId: this.userId,
					remark: ''
				}
				this.userOptions = [{
					id: this.userId,
					username: this.username
				}]
				console.log('this.user', this.userId)
				console.log('this.form', this.username)
				
				this.dialogVisible = true
			},

			// 编辑线索
			handleEdit(row) {
				this.dialogType = 'edit'
				this.form = {
					id: row.id,
					leadsName: row.leadsName,
					customerId: row.customerId,
					followup: row.followup,
					isTransform: row.isTransform,
					ownerUserId: row.ownerUserId,
					remark: row.remark,
					status: row.status,
					customerName:row.customerName,
					mobile:row.mobile
				}
				this.userOptions = [{
					id: row.ownerUserId,
					username: row.ownerName
				}]
				this.dialogVisible = true
				console.log('this.form', this.form)
				console.log('this.form', this.userOptions)
			},
			async handleCustomerSearch(query) {
				if (query) {
					this.customerSearchLoading = true
					try {
						const res = await searchCustomers({
							name: query
						})
						this.customerOptions = res.data
					} catch (error) {
						console.error('搜索客户失败:', error)
						ElMessage.error('搜索客户失败')
					} finally {
						this.customerSearchLoading = false
					}
				} else {
					this.customerOptions = []
				}
			},
			// async handleCustomerChange(customerId) {
			//   if (customerId) {
			//     this.opportunityLoading = true
			//     try {
			//       const res = await getCustomerOpportunities({ cuId: customerId })
			//       this.opportunityOptions = res.data
			//     } catch (error) {
			//       console.error('获取客户商机失败:', error)
			//       ElMessage.error('获取客户商机失败')
			//     } finally {
			//       this.opportunityLoading = false
			//     }
			//   } else {
			//     this.opportunityOptions = []
			//     this.contractOptions = []
			//   }
			//   this.paymentForm.businessId = ''
			//   this.paymentForm.contractId = ''
			// },

			// 查看线索
			async handleView(row) {
				this.viewDialogVisible = true
				try {
					// const [detailRes, followupRes, quotationsRes] = await Promise.all([
					//   getLeadDetail({ id: row.id }),
					//   getLeadFollowupList({ leadId: row.id }),
					//   getLeadQuotations({ leadId: row.id })
					// ])

					this.currentLead = row
					// this.followupRecords = followupRes.data
					// this.quotations = quotationsRes.data
				} catch (error) {
					console.error('获取线索详情失败:', error)
					this.$message.error('获取线索详情失败')
				}
			},

			// 转化线索
			async handleConvert(row) {
				this.currentLeadId = row.id
				console.log(row.id);

				try {
					await ElMessageBox.confirm('确定要将该线索转化为商机吗吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					console.log(row.id);

					await convertLead({
						id: row.id
					})
					ElMessage.success('转化成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('转化线索失败:', error)
					}
				}
			},

			// 分配线索
			handleAssign(row) {
				this.currentLeadId = row.id
				Object.assign(this.assignForm, {
					owner: '',
					remark: ''
				})
				this.assignDialogVisible = true
			},

			// 删除线索
			async handleDelete(row) {
				try {
					await ElMessageBox.confirm('确定要删除该线索吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})

					await deleteLead(row.id)
					ElMessage.success('删除成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除线索失败:', error)
					}
				}
			},

			// 提交表单
			async handleSubmit() {
				try {
					await this.$refs.formRef.validate()

					if (this.dialogType === 'add') {
						await addLead(this.form)
						ElMessage.success('添加成功')
					} else {
						await updateLead(this.form)
						ElMessage.success('更新成功')
					}

					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('提交表单失败:', error)
				}
			},

			// 提交转化
			async handleConvertSubmit() {
				try {
					await this.$refs.convertFormRef.validate()
					await convertLead(this.currentLeadId, this.convertForm)
					ElMessage.success('转化成功')
					this.convertDialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('转化失败:', error)
				}
			},

			// 提交分配
			async handleAssignSubmit() {
				try {
					await this.$refs.assignFormRef.validate()
					await assignLead(this.currentLeadId, this.assignForm)
					ElMessage.success('分配成功')
					this.assignDialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('分配失败:', error)
				}
			},

			formatDate(date) {
				return this.formatDateTime(date, 'YYYY-MM-DD')
			},

			formatAmount(amount) {
				if (!amount && amount !== 0) return '--'
				return amount.toLocaleString('zh-CN', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				})
			},

			getFollowupType(type) {
				const typeMap = {
					1: 'primary',
					2: 'success',
					3: 'warning',
					4: 'danger'
				}
				return typeMap[type] || 'info'
			},

			getFollowupMethod(method) {
				const methodMap = {
					1: '电话',
					2: '邮件',
					3: '拜访',
					4: '其他'
				}
				return methodMap[method] || method
			},

			getQuotationStatusType(status) {
				const statusMap = {
					0: 'primary',
					1: 'success',
					2: 'danger'
				}
				return statusMap[status] || 'info'
			},

			getQuotationStatusText(status) {
				const statusMap = {
					0: '审核中',
					1: '已审核',
					2: '已拒绝'
				}
				return statusMap[status] || status
			},

			handleViewQuotation(row) {
				// TODO: 实现查看报价功能
				console.log('查看报价:', row)
			},

			// 获取跟进状态类型
			getFollowupStatusType(status) {
				if (status === null || status === undefined) return 'info'
				const types = {
					0: 'info', // 未跟进
					1: 'primary' // 跟进中
				}
				return types[status] || 'info'
			},

			// 获取跟进状态文本
			getFollowupStatusText(status) {
				if (status === null || status === undefined) return '未知'
				const texts = {
					0: '未跟进',
					1: '跟进中'
				}
				return texts[status] || '未知'
			},

			// 获取转化状态类型
			getTransformStatusType(status) {
				if (status === null || status === undefined) return 'info'
				const types = {
					0: 'info', // 未转化
					1: 'success' // 已转化
				}
				return types[status] || 'info'
			},

			// 获取转化状态文本
			getTransformStatusText(status) {
				if (status === null || status === undefined) return '未知'
				const texts = {
					0: '未转化',
					1: '已转化'
				}
				return texts[status] || '未知'
			}
		},

		mounted() {
			// 添加 ResizeObserver 处理
			const debouncedLayout = debounce(() => {
				if (this.rafId) {
					cancelAnimationFrame(this.rafId)
				}
				this.rafId = requestAnimationFrame(() => {
					if (this.$refs.leadTable && this.$refs.leadTable.$el) {
						this.$refs.leadTable.doLayout()
					}
				})
			}, 100)

			this.resizeObserver = new ResizeObserver(() => {
				debouncedLayout()
			})

			// 只在表格存在时观察
			if (this.$refs.leadTable && this.$refs.leadTable.$el) {
				this.resizeObserver.observe(this.$refs.leadTable.$el)
			}
		},

		beforeUnmount() {
			// 清理 ResizeObserver 和 RAF
			if (this.rafId) {
				cancelAnimationFrame(this.rafId)
				this.rafId = null
			}
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
				this.resizeObserver = null
			}
		}
	}
</script>

<style scoped>
	.table-card {
		height: auto;
		min-height: calc(100% - 40px);
	}

	:deep(.el-form--inline .el-form-item) {
		margin-right: 0;
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	.timeline-item-content {
		padding: 8px 0;
	}

	.timeline-item-content h4 {
		margin: 0 0 8px 0;
		color: #303133;
	}

	.timeline-item-content p {
		margin: 4px 0;
		color: #606266;
		line-height: 1.5;
	}

	.el-dialog {
		display: flex;
		flex-direction: column;
		margin: 0 !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-height: calc(100vh - 30px);
		max-width: calc(100vw - 30px);
	}

	.el-dialog__body {
		flex: 1;
		overflow: auto;
		padding: 20px;
	}
</style>